import { createComponent } from '@lit/react';
import React from 'react';
import { SDSRadio } from '../sds-radio/sds-radio';
import { SheriffEventName } from './types';

export const SDSRadioWrapper = createComponent({
	tagName: 'sds-radio',
	elementClass: SDSRadio,
	react: React,
	events: {
		onChange: 'change' as SheriffEventName,
		onFocus: 'focus' as SheriffEventName,
		onBlur: 'blur' as SheriffEventName,
	},
});
